import React from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';

export const MobileTable = ({ data, columns, actions }) => {
  return (
    <Stack spacing={2}>
      {data.map((row, index) => (
        <Card key={index} variant="outlined">
          <CardContent>
            <Stack spacing={1}>
              {columns.map((column, colIndex) => (
                <Box key={colIndex} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="caption" color="text.secondary">
                    {column.label}:
                  </Typography>
                  <Typography>
                    {column.format ? column.format(row[column.field]) : row[column.field]}
                  </Typography>
                </Box>
              ))}
              {actions && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
                  {actions(row)}
                </Box>
              )}
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}; 